const determineLineItems = (variantId, price, cart, cartSettings) => {
  const giftProductEncodedId = cartSettings?.giftProduct?.id;
  const giftThreshold = cartSettings?.giftThreshold;
  const triggeredProducts = cartSettings?.triggeredVariants;
  const freeProductDecodedId = giftProductEncodedId ? atob(giftProductEncodedId) : "";
  const freeVariantInCart = cart?.items?.find(item => freeProductDecodedId.includes(item.variantId));
  const totalPrice = +cart?.totalPriceV2?.amount;
  const total = totalPrice + price;

  const lineItems = [{ 
    variantId, quantity: 1
  }];

  if (variantId !== giftProductEncodedId && !freeVariantInCart) {
    if (!giftThreshold) {
      const isTriggeredVariantAddedToCart = triggeredProducts?.some(item => item.id === variantId);
      const isTriggeredProductInCart = cart.items?.some(cartItem =>
        triggeredProducts?.some(triggeredProduct =>
          cartItem.variantId === atob(triggeredProduct.id)
        )
      );

      if (isTriggeredProductInCart || isTriggeredVariantAddedToCart) {
        lineItems.push({ 
          variantId: giftProductEncodedId, quantity: 1
        });
      }
    } else if (totalPrice > giftThreshold || total > giftThreshold) {
      lineItems.push({ 
        variantId: giftProductEncodedId, quantity: 1
      });
    }
  }

  return lineItems;
};

export default determineLineItems;